<div class="container">
  <!-- ----------------------------- Create DWM Task ------------------------------------------------- -->

  <ion-row class="ion-align-items-center">
    <ion-col size="12" size-md="auto">
      <h6 class="comp-header">Update DWM</h6>
    </ion-col>
    <ion-col size="12" size-md>
      <div class="phi-flex-wrap-center phi-gap-12 ion-justify-content-end">
        <!-- ----------------------------- Compliance Score ------------------------- -->
        <!-- <span class="compliance-score">Compliance Score: 20</span> -->
        <!-- ----------------------------- Achievement ------------------------- -->
        <!-- <span class="achievment">Achievement: 20</span> -->
        <!-- --------------------------- Year ------------------------------------------------------------ -->
        <!-- <mat-form-field class="w-100 mw-sm-150 mat-height40 mat-input-style">
          <mat-select placeholder="Select" [(ngModel)]="selectedYearForDWM" (selectionChange)="getYearSetupForDWM(selectedYearForDWM)">
            <mat-option [value]="item.year" *ngFor="let item of pmsYears">
              {{ sharedService.transformYearToFyFormat(item.year) }}
            </mat-option>
          </mat-select>
        </mat-form-field> -->
        <!-- --------------------------- Date  ------------------------------------------------------------ -->
        <mat-form-field class="w-100 mw-sm-150 mat-height40 mat-input-style">
          <input readonly matInput [matDatepicker]="fromToDate" placeholder="DD/MM/YYYY" [(ngModel)]="dwmPlusFormDate" (dateChange)="onDateChange()" />
          <mat-datepicker-toggle matIconSuffix [for]="fromToDate"></mat-datepicker-toggle>
          <mat-datepicker #fromToDate></mat-datepicker>
        </mat-form-field>
      </div>
    </ion-col>
  </ion-row>
  <!-- ----------------------------------- Table CardBox --------------------- -->
  <div class="table-card-box mb-15">
    <ion-row class="ion-align-items-center">
      <ion-col size="12" size-md="auto">
        <mat-form-field class="w-100 mw-sm-250 mat-height40 mat-input-style">
          <mat-icon matPrefix>search</mat-icon>
          <input matInput type="search" placeholder="Search" [(ngModel)]="searchTaskString" (input)="onSearchTask(searchTaskString)" />
        </mat-form-field>
      </ion-col>
      <ion-col size="12" size-md>
        <div class="phi-flex-wrap-center phi-gap-12 ion-justify-content-end">
          <!-- ---------------------------- Save ---------------------------- -->
          <!-- <button *ngIf="isRNDEmployee" type="button" class="dwm_btn fs-14 fs_12ForMobile" [style.background-color]="buttonColorName" (click)="saveTask()">Save</button> -->
          <button *ngIf="isRNDEmployee" type="button" class="dwm_btn fs-14 fs_12ForMobile" [style.background-color]="buttonColorName" [disabled]="!isDwmPageEditable()" (click)="saveTask()">Save</button>

          <!-- --------------------------- Add New --------------------------- -->
          <!-- <span *ngIf="isRNDEmployee" class="add-new" (click)="addNewRow()">+ Add New</span> -->
          <span *ngIf="isRNDEmployee" class="add-new" [class.disabled]="!isDwmPageEditable()" (click)="isDwmPageEditable() ? addNewRow() : null">+ Add New</span>

          <!-- -------------------------- Skip Day ---------------------------- -->

          <!-- Skip Day -->
          <!-- <span *ngIf="!hasSkipDayRecord && !isSkipDaySubmitted" class="skip-day" (click)="skipDayModalPopup()">Request Skip Day</span> -->
          <span *ngIf="!hasSkipDayRecord && !isSkipDaySubmitted" class="skip-day" [class.disabled]="!isDwmPageEditable()" (click)="isDwmPageEditable() ? skipDayModalPopup() : null">Request Skip Day</span>

          <!-- Submitted -->
          <span *ngIf="isSkipDaySubmitted" class="submittedForApproval">Submitted for Approval</span>

          <!-- Rejected -->
          <span *ngIf="isSkipDayRejected" class="rejectedForApproval" matTooltip="{{ rejectedReason }}" (click)="onRejectedSkipDayClick()">Rejected skip day(Resubmit)</span>

          <!-- Approved -->
          <span *ngIf="isSkipDayApproved" class="submittedForApproval">Day is Skipped</span>

          <!-- -------------------------- Dwonload  button ---------------------------- -->
          <div class="file-icons">
            <img src="assets/svg/pdf.svg" class="file-icon" (click)="downloadPDFAndExcel('pdf')" />
            <img src="assets/svg/excel.svg" class="file-icon ml-10" (click)="downloadPDFAndExcel('excel')" />
          </div>
        </div>
      </ion-col>
    </ion-row>

    <!-- ================================  Update Task  Table For Non R&D ============================= -->
    <ion-row>
      <ion-col>
        <div class="table-container" id="dwmTable">
          <table class="hover mb-15">
            <thead>
              <tr>
                <ng-container *ngFor="let item of dwmTableHeaderNames">
                  <th
                    class="fs-14 fs_12ForMobile font_bold cl-black"
                    *ngIf="
                      !(
                        isL4AndAboveEmployee &&
                        (item === 'Time From' || item === 'Time To')
                      ) &&
                      (isRNDEmployee ||
                        (item !== 'Product No' &&
                          item !== 'Plant' &&
                          item !== 'Duration' &&
                          (item !== 'Action' || hasNewRow)))
                    ">
                    <div class="p-5 verticle-center justify-content-space-between icon-style">
                      <!-- ----------------------- Mandatory Fields ------------------------ -->
                      {{ item
                      }}
                      <span
                        class="red-cl"
                        *ngIf="
                          item === 'Category' ||
                          item === 'Actionable' ||
                          item === 'Plant' ||
                          item === 'Product No' ||
                          item === 'Duration' ||
                          item === 'Status'
                        ">
                        &nbsp;*
                      </span>

                      <!-- ------------------- Ascending/Descending  Order ------------------------ -->
                      <div class="d-flex flex-column ml-10">
                        <i (click)="onSortAssending(item)" class="material-icons materialIconsHeight cp">arrow_drop_up</i>
                        <i (click)="onSortDesending(item)" class="material-icons materialIconsHeight cp">arrow_drop_down</i>
                      </div>
                    </div>
                  </th>
                </ng-container>
              </tr>
            </thead>

            <!-- ----------------------- Table Data -------------------------- -->
            <tbody>
              <tr *ngFor="let item of dwmUpdateData; let i = index" [ngClass]="{ 'bg-edit-row': item.isEdit }">
                <!-- -----------------------  Category ------------------------->
                <td>
                  {{ item.categoryName }}
                </td>

                <!-- ------------------------------------- Actionable ----------------------------->
                <td>
                  <textarea
                    rows="1"
                    cols="4"
                    maxlength="500"
                    class="edittextarea"
                    [(ngModel)]="item.actionable"
                    (keyup)="checkMaxLength(item.actionable)"
                    placeholder="Type here.."
                    [readonly]="
                      !(
                        item.categoryName === 'R&D' &&
                        (item.isNew || isRNDEmployee)
                      )
                    "></textarea>
                </td>

                <!-- ----------------------------- Product No ------------------------------------ -->
                <td *ngIf="isRNDEmployee">
                  <ng-select class="w-100 mw-sm-250" [clearable]="false" placeholder="Select Product" [(ngModel)]="item.productId" [items]="productList" bindLabel="productNumber" bindValue="productId" appendTo="body" dropdownPosition="top" [disabled]="item.categoryName !== 'R&D'" (change)="onProductChange(item)"></ng-select>
                </td>

                <!-- ---------------------------- PLant ------------------------------ -->
                <td *ngIf="isRNDEmployee">
                  {{ item.plantLocation }}
                </td>

                <!-- -------------------------- Duration ----------------------------- -->
                <td *ngIf="isRNDEmployee">
                  <input matInput class="dwm-input table-input" type="text" inputmode="numeric" placeholder="HH:MM" maxlength="5" [disabled]="item.categoryName !== 'R&D'" [(ngModel)]="item.dwmDuration" (keydown)="onDurationInput(item, $event)" (input)="onDurationInput(item, $event)" (blur)="onDurationBlur(item)" />
                  <mat-error *ngIf="maxDurationError">Maximum allowed duration is 24:00</mat-error>
                </td>

                <!-- Date  -->
                <td>
                  <mat-form-field class="w-100 mw-sm-150 mat mat-height32 mat-input-style select-date-pikker">
                    <input matInput [matDatepicker]="picker" placeholder="Select date" [(ngModel)]="item.dwmEventDate" [min]="today" [disabled]="item.categoryName !== 'R&D'" />
                    <mat-datepicker-toggle matIconSuffix [for]="picker"></mat-datepicker-toggle>
                    <mat-datepicker #picker></mat-datepicker>
                  </mat-form-field>
                </td>

                <!-- -------------------------- Time From ----------------------------- -->
                <td *ngIf="!isL4AndAboveEmployee" [ngClass]="{ 'na-cell': !item.timeFrom }">
                  {{ item.timeFrom ? (item.timeFrom | timeAmPm) : 'N/A' }}
                </td>

                <!-- -------------------------- Time To ----------------------------- -->
                <td *ngIf="!isL4AndAboveEmployee" [ngClass]="{ 'na-cell': !item.timeTo }">
                  {{ item.timeTo ? (item.timeTo | timeAmPm) : 'N/A' }}
                </td>

                <!-- -------------------------- Frequency  ----------------------------- -->
                <td>
                  {{ formatedataVariable(item.dwmFrequency) }}
                </td>

                <!-- -------------------------- Status ----------------------------- -->

                <td>
                  <div class="dwm-status-icons">
                    <button class="transparent-ghost-btn radius-100" (click)="isDwmEditable(item.dwmEventDate) ? changeStatus(item, 'Not_Started') : null">
                      <mat-icon class="dwm-status-icon not-started" [matTooltip]="dwmGenericServiceService.getStatusLabel('Not_Started')" [class.active]="item.dwmStatus === 'Not_Started'" [class.disabled]="!isDwmEditable(item.dwmEventDate)">cancel</mat-icon>
                    </button>

                    <button class="transparent-ghost-btn radius-100" (click)="isDwmEditable(item.dwmEventDate) ? changeStatus(item, 'In_Progress') : null">
                      <mat-icon class="dwm-status-icon in-progress" [matTooltip]="dwmGenericServiceService.getStatusLabel('In_Progress')" [class.active]="item.dwmStatus === 'In_Progress'" [class.disabled]="!isDwmEditable(item.dwmEventDate)">radio_button_checked</mat-icon>
                    </button>

                    <button class="transparent-ghost-btn radius-100" [disabled]="isExitedSelectedDate" (click)="isDwmEditable(item.dwmEventDate) ? changeStatus(item, 'Completed') : null">
                      <mat-icon class="dwm-status-icon complete" [matTooltip]="dwmGenericServiceService.getStatusLabel('Completed')" [class.active]="item.dwmStatus === 'Completed' && !item.doneWithDelay" [class.disabled]="!isDwmEditable(item.dwmEventDate) ">check_circle</mat-icon>
                    </button>

                    <button class="transparent-ghost-btn radius-100" [disabled]="!isExitedSelectedDate" (click)="isDwmEditable(item.dwmEventDate) && isPastDateOnly(item.dwmEventDate) ? changeStatus(item, 'Completed', true) : null">
                      <mat-icon class="dwm-status-icon complete-delay" [matTooltip]="dwmGenericServiceService.getStatusLabel('Done_with_delay')" [class.active]="item.doneWithDelay === true" [class.disabled]="!isDwmEditable(item.dwmEventDate)  || !isPastDateOnly(item.dwmEventDate) ">check_circle</mat-icon>
                    </button>
                  </div>
                </td>

                <!-- -------------------------- Employee Comment----------------------------- -->
                <td>
                  <textarea
                    rows="1"
                    cols="4"
                    maxlength="500"
                    class="edittextarea"
                    [(ngModel)]="item.empComments"
                    (keyup)="checkMaxLength(item.empComments)"
                    placeholder="Type here.."
                    [disabled]="
                      !(
                        item.isNew ||
                        isEmployeeOnly ||
                        isEmployeeAndManager ||
                        isEmployeeAndHod
                      ) || !isDwmEditable(item.dwmEventDate)
                    "
                    (focus)="onEmpCommentFocus(item)"
                    (blur)="onEmpCommentBlur(item)"></textarea>
                </td>

                <!-- -------------------------- Manager Comment ----------------------------- -->
                <td>
                  <textarea rows="1" cols="4" maxlength="500" (keyup)="checkMaxLength(item.empComment)" class="edittextarea" [(ngModel)]="item.managerComments" [disabled]="true"></textarea>
                </td>

                <!-- -------------------------- Document Attachment ----------------------------- -->
                <td class="fs-14 fs_12ForMobile font_regular">
                  <!-- hidden file input -->
                  <input type="file" [disabled]="!isDwmEditable(item.dwmEventDate)" multiple #fileInput hidden (change)="uploadDWMAttachments($event, item)" />

                  <!-- 📎 Attachment icon -->
                  <span class="attachment-icon cp" [class.disabled-upload]="!isDwmEditable(item.dwmEventDate)" matTooltip="Upload" *ngIf="!item.hasSavedAttachments" (click)="isDwmEditable(item.dwmEventDate) ? fileInput.click() : null">
                    <img class="attachment" src="assets/icon/attachment.svg" />
                  </span>

                  <!-- See Attachment + Remove -->
                  <span *ngIf="item.hasSavedAttachments" class="see-attachment-wrapper">
                    <span class="see-attachment cp" (click)="openMisPreview(item)">See Attachment</span>
                    <span class="remove-attachment cp" [class.disabled]="!isDwmEditable(item.dwmEventDate)" (click)="isDwmEditable(item.dwmEventDate) ? removeSavedAttachments(item) : null" title="Remove Attachment">✕</span>
                  </span>
                </td>

                <!-- -------------------------- Audit Trail ----------------------------- -->
                <td>
                  <button mat-icon-button color="success" (click)="auditpopup(item.id)">
                    <ion-icon name="document-text-outline"></ion-icon>
                  </button>
                </td>

                <!-- ------------------------ Delete Row ------------------------------------ -->
                <td *ngIf="item !== 'Action' || hasNewRow">
                  <button *ngIf="item.isNew" mat-icon-button color="warn" (click)="deleteRow(i)">
                    <ion-icon name="trash-outline"></ion-icon>
                  </button>
                </td>
              </tr>
            </tbody>
          </table>
        </div>

        <div class="phi-flex-wrap-center-space-between-gap6 mt-10" *ngIf="dwmUpdateData.length !== 0">
          <ion-label class="fs-14 fs_12ForMobile font_bold black_color">Showing {{ showingCount }} to {{ showingOfCount }} of {{ totalTaskCount }} entries</ion-label>

          <div class="phi-flex-wrap-center phi-gap-12">
            <div class="phi-flex-wrap-center phi-gap-8">
              <ion-label class="fs-14 fs_12ForMobile font_regular black_color">Show</ion-label>
              <mat-form-field class="w70px mat-height40 mat-input-style">
                <mat-select placeholder="Select" (selectionChange)="onSelectSizeCount()" [(ngModel)]="selectedSizeOfTask">
                  <mat-option [value]="25">25</mat-option>
                  <mat-option [value]="50">50</mat-option>
                  <mat-option [value]="75">75</mat-option>
                  <mat-option [value]="100">100</mat-option>
                </mat-select>
              </mat-form-field>
              <ion-label class="fs-14 fs_12ForMobile font_regular black_color">entries</ion-label>
            </div>

            <ul class="dt_pagination">
              <li class="active fs-16 fs_14ForMobile font_regular">
                {{ currentPageNumber }}
              </li>
              <span class="fs-14 fs_12ForMobile font_regular p-10">of {{ totalTaskPages }}</span>
              <li class="fs-24 fs_18ForMobile cp" (click)="previousPageTask()" [ngClass]="{ disableBtn: currentPageNumber === 1 }">&lt;</li>
              <li class="fs-24 fs_18ForMobile cp" (click)="nextPageTask()" [ngClass]="{ disableBtn: currentPageNumber >= totalTaskPages }">&gt;</li>
            </ul>
          </div>
        </div>
      </ion-col>
    </ion-row>
  </div>
</div>
